// extracted by mini-css-extract-plugin
export default {"mineLevelLine":"styles_mineLevelLine__oUEDB","mineLevelProgress":"styles_mineLevelProgress__C9YfW","line":"styles_line__oXM4N","table":"styles_table__tJSU2"};